//获取公司详情
import { useState, useEffect } from 'react'
import { getDepartmentListAPI } from '@/apis/department'

function useDepartmentList(id) {
    const [departmentList, setDepartmentList] = useState([])
    useEffect(() => {
        const getCompanyList = async () => {
            const res = await getDepartmentListAPI(id)
            setDepartmentList(res.data)

        }
        getCompanyList()
    }, [id])
    return {
        departmentList
    }
}

export { useDepartmentList } 